// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumbs_Breadcrumb__XQrGh","BreadcrumbItem":"Breadcrumbs_BreadcrumbItem__3G_Z8"};